import React from 'react'

import { bool, func, shape, string } from 'prop-types'
import { Modal, ModalBody } from 'components/qstrap'
import Typography from 'components/atoms/Typography'
import Button from 'components/atoms/Button/Button'

const NewModal = ({ isOpen, message, title, cancel, success }) => (
  <Modal autoFocus={false} isOpen={isOpen} fade={false} className="new-modal">
    <ModalBody>
      <Typography component="p" variant="subheading" className="new-modal__title">
        {title}
      </Typography>
      <Typography component="p" variant="subbody" className="new-modal__message m-b-md">
        {message}
      </Typography>
      <div className="new-modal__btn-group">
        {cancel && (
          <Button
            onClick={cancel.handle}
            variant="solid"
            className="new-modal__btn"
          >
            {cancel.text}
          </Button>
        )}
        <Button
          variant="default"
          onClick={success.handle}
          className="new-modal__btn"
        >
          {success.text}
        </Button>
      </div>
    </ModalBody>
    <style jsx global>
      {`
        .new-modal {
          margin: 200px 24px 0;
          .modal-body {
            padding: 16px;
          }
          &__title,
          &__message {
            color: #1a344f !important;
            text-align: center;
          }
          &__title {
            margin-bottom: 8px !important;
            font-weight: bold !important;
          }
          &__btn-group {
            display: flex;
          }
          &__btn {
            width: 100%;
            font-weight: bold;
            padding: 12px auto;
            font-size: 14px;
            &:first-of-type {
              margin-right: 8px;
            }
          }
          .button-solid {
            border: solid 1px #7d92a9;
            color: #1a344f;
          }
          @media screen and (min-width: 768px) {
            margin: 250px auto 0;
            max-width: 46rem;
            .modal-body {
              padding: 40px;
            }
            &__title,
            &__message {
              text-align: left;
            }
            &__title {
              font-size: 28px !important;
              line-height: 30px !important;
              margin-bottom: 24px !important;
            }
            &__btn-group {
              justify-content: flex-end;
            }
            &__btn {
              width: inherit;
              font-size: 16px;
              padding: 16px 36px;
            }
          }
        }
        .modal-backdrop {
          background-color: #1a344f;
          opacity: 0.8;
        }
      `}
    </style>
  </Modal>
)

const actionProps = shape({
  handle: func,
  text: string,
})

NewModal.propTypes = {
  isOpen: bool,
  message: string,
  title: string,
  cancel: actionProps,
  success: actionProps,
}

export default NewModal
